import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { createFocusTrap } from 'focus-trap'

export default () => ({
    activeIndex: null,

    get maxIndex() {
        return this.$refs.gallery?.children?.length - 1
    },

    get hasPrevious() {
        return this.activeIndex > 0
    },

    get hasNext() {
        return this.activeIndex < this.maxIndex
    },

    init() {
        const modal = this.$refs.modal
        const boundOnKeyUp = this.boundOnKeyUp.bind(this)
        const focusTrap = createFocusTrap(modal)

        this.$watch('activeIndex', (activeIndex) => {
            let templateHtml = ''

            if (activeIndex === null) {
                window.removeEventListener('keyup', boundOnKeyUp)
                enableBodyScroll(modal)
                focusTrap.deactivate()
            } else {
                templateHtml =
                    this.$refs.gallery.children[activeIndex]?.querySelector(
                        'template'
                    )?.innerHTML
                window.addEventListener('keyup', boundOnKeyUp)
                this.$nextTick(() => {
                    disableBodyScroll(modal, {
                        reserveScrollBarGap: true,
                    })
                    focusTrap.activate()
                })
            }

            this.$refs.target.innerHTML = templateHtml
        })
    },

    boundOnKeyUp(event) {
        if (event.key === 'ArrowLeft') {
            this.previous()
        }

        if (event.key === 'ArrowRight') {
            this.next()
        }

        if (event.key === 'Escape') {
            this.close()
        }
    },

    show(index) {
        this.activeIndex = index
    },

    previous() {
        this.activeIndex = Math.max(0, this.activeIndex - 1)
    },

    next() {
        const next = Math.min(this.activeIndex + 1, this.maxIndex)

        this.activeIndex = next
    },

    close() {
        this.activeIndex = null
    },
})
